import exportReportRmc from './exportReportRmc'

const rmcs = {
  exportReportRmc,
}

export default rmcs
